<svg viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="M0 0h24v24H0z" fill="none"/>
        <path d="M3 19h18v2H3v-2zM13 9h7l-8 8-8-8h7V1h2v8z"/>
    </g>
</svg>